import UpdateTimegridFormContainer from './UpdateTimegridFormContainer';

export default UpdateTimegridFormContainer;
